import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import {
  compose,
  setPropTypes,
  withState,
  lifecycle,
  withHandlers
} from 'recompose';
import { withRouter } from 'react-router';
import { withStyles } from '@material-ui/core/styles';
import Modal from '@material-ui/core/Modal';
import Table from '@material-ui/core/Table';
import GochiChildFoodListTableHead from '../../components/molecules/GochiChildFoodListTableHead';
import GochiChildFoodListTableBody from '../../components/molecules/GochiChildFoodListTableBody';
// import TablePagination from '../../components/molecules/TablePagination';
import ExPagination from '../../components/molecules/ExPagination';
import GochiChildFoodListDetail from './GochiChildFoodListDetail';
import GochiChildFoodListEdit from './GochiChildFoodListEdit';
import DeleteDialog from '../../components/molecules/DeleteDialog';
import ProgressDialog from '../../components/molecules/ProgressDialog';
// import ShowHideDialog from '../../components/molecules/ConfirmDialog';
import {
  getGochiChildFoodLists,
  getGochiChildFoodListDetail,
  deleteGochiChildFoodList
  //   showHideGochiMenu
} from '../../actions/GochiChildFoodLists';
import { sendLogin } from '../../auth/Auth';

const styles = {
  scrollTable: {
    maxHeight: '60vh',
    overflowX: 'scroll',
    whiteSpace: 'nowrap'
  }
};

const propTypes = {
  classes: PropTypes.object.isRequired
};

const enhance = compose(
  connect(
    state => ({
      list: state.gochiChildFoodLists.list,
      totalCount: state.gochiChildFoodLists.count,
      offset: state.gochiChildFoodLists.offset,
      detail: state.gochiChildFoodLists.detail
    }),
    dispatch => ({
      actions: bindActionCreators(
        {
          getGochiChildFoodLists,
          getGochiChildFoodListDetail,
          deleteGochiChildFoodList
          //   showHideGochiMenu
        },
        dispatch
      )
    })
  ),
  setPropTypes(propTypes),
  withState('openDetailModal', 'updateOpenDetailModal', false),
  withState('openEdit', 'updateOpenEdit', false),
  withState('openEditConfirm', 'updateOpenEditConfirm', false),
  withState('openEditModal', 'updateOpenEditModal', false),
  withState('openDelete', 'updateOpenDelete', false),
  withState('openDeleteProgress', 'updateOpenDeleteProgress', false),
  withState('loading', 'updateLoading', false),
  withState('isDeleteSuccess', 'updateIsDeleteSuccess', false),
  withState('resultMessage', 'setResultMessage', ''),
  withState('shopId', 'setShopId', 0),
  withState('shopName', 'setShopName', ''),
  withState('groupId', 'setGroupId', 0),
  withState('groupName', 'setGroupName', ''),
  withState('childFoodId', 'setChildFoodId', 0),
  withState('childFoodName', 'setChildFoodName', ''),
  withState('menuChild', 'setMenuChild', ''),
  withState('childFoodDescription', 'setChildFoodDescription', ''),
  withState('childFoodImage', 'setChildFoodImage', null),
  withState('previewImage', 'setPreviewImage', null),
  withState('updatedAt', 'setUpdatedAt', ''),
  withState('createdAt', 'setCreatedAt', ''),
  withState('rowsPerPage', 'setRowsPerPage', 100),
  withState('targetRowId', 'setTargetRowId', 0),
  withState('order', 'setOrder', 'asc'),
  withState('orderBy', 'setOrderBy', null),
  withState('page', 'setPage', 0),
  withState('otherLanguages', 'setOtherLanguages', {}),
  withHandlers({
    checkSession: props => data => {
      if (data.error === true && data.payload.status === 403) {
        sendLogin(props);
      }
      return data;
    },
    handleChangeRowsPerPage: props => (event, rowsPerPage) => {
      props.setRowsPerPage(rowsPerPage);
    },
    handleRequestSort: props => property => {
      const isDesc = props.orderBy === property && props.order === 'desc';
      props.setOrder(isDesc ? 'asc' : 'desc');
      props.setOrderBy(property);
    }
  }),
  lifecycle({
    componentDidMount() {}
  })
);

const Main = enhance(
  ({
    classes,
    actions,
    checkSession,
    roles,
    progress,
    searchKey,
    page,
    selectedPage,
    handleChangePage,
    list,
    totalCount,
    offset,
    name,
    openDetailModal,
    updateOpenDetailModal,
    openDelete,
    updateOpenDelete,
    rowsPerPage,
    targetRowId,
    setTargetRowId,
    openEdit,
    updateOpenEdit,
    openEditConfirm,
    updateOpenEditConfirm,
    openDeleteProgress,
    updateOpenDeleteProgress,
    loading,
    updateLoading,
    isDeleteSuccess,
    updateIsDeleteSuccess,
    resultMessage,
    setResultMessage,
    shopId,
    setShopId,
    shopName,
    setShopName,
    groupId,
    setGroupId,
    groupName,
    setGroupName,
    childFoodId,
    setChildFoodId,
    childFoodName,
    setChildFoodName,
    childFoodDescription,
    setChildFoodDescription,
    childFoodImage,
    setChildFoodImage,
    menuChild,
    setMenuChild,
    createdAt,
    setCreatedAt,
    updatedAt,
    setUpdatedAt,
    order,
    orderBy,
    handleChangeRowsPerPage,
    handleRequestSort,
    otherLanguages,
    setOtherLanguages
  }) => {
    const emptyRows =
      rowsPerPage - Math.min(rowsPerPage, totalCount - page * rowsPerPage);
    // const paramShowHide = {
    //   showHide
    // };
    const detail = {
      shopId,
      shopName,
      groupId,
      groupName,
      childFoodId,
      childFoodName,
      childFoodDescription,
      childFoodImage,
      menuChild,
      createdAt,
      updatedAt,
      otherLanguages
    };
    const getGochiChildFoodList = async id => {
      await actions.getGochiChildFoodListDetail(id).then(detailData => {
        checkSession(detailData);
        setShopId(detailData.payload.shop.shopId);
        setShopName(detailData.payload.shop.shopName);
        setGroupId(detailData.payload.group.groupId);
        setGroupName(detailData.payload.group.groupName);
        setChildFoodId(detailData.payload.childFoodId);
        setChildFoodName(detailData.payload.childFoodName);
        setChildFoodDescription(detailData.payload.childFoodDescription);
        setChildFoodImage(detailData.payload.childFoodImage);
        setMenuChild(detailData.payload.menuChild);
        setCreatedAt(detailData.payload.createdAt);
        setUpdatedAt(detailData.payload.updatedAt);
        setOtherLanguages(detailData.payload.otherLanguages);
      });
    };
    const detailOpenAction = params => {
      progress.updateLoading(true);
      progress.updateOpenProgress(true);
      getGochiChildFoodList(params.id)
        .then(() => {
          progress.updateOpenProgress(false);
          progress.updateLoading(false);
          updateOpenDetailModal(true);
        })
        .catch(() => {
          progress.updateOpenProgress(false);
          progress.updateLoading(false);
        });
    };
    const editOpenAction = id => {
      progress.updateLoading(true);
      progress.updateOpenProgress(true);
      getGochiChildFoodList(id)
        .then(() => {
          progress.updateOpenProgress(false);
          progress.updateLoading(false);
          updateOpenEdit(true);
        })
        .catch(() => {
          progress.updateOpenProgress(false);
          progress.updateLoading(false);
        });
    };
    const deleteOpenAction = id => {
      updateOpenDelete(true);
      setTargetRowId(id);
    };
    const cancelAction = () => updateOpenDelete(false);
    const deleteAction = async () => {
      updateLoading(true);
      updateOpenDeleteProgress(true);
      const deletedChildFoodList = await actions
        .deleteGochiChildFoodList(targetRowId)
        .then(data => checkSession(data));
      if (deletedChildFoodList.type === 'DELETE_GOCHI_CHILD_FOOD_SUCCESS') {
        updateIsDeleteSuccess(true);
        handleChangePage(null, selectedPage, rowsPerPage);
        setResultMessage('削除が完了しました。');
        updateLoading(false);
      } else {
        updateIsDeleteSuccess(false);
        setResultMessage('削除に失敗しました。');
        updateLoading(false);
      }
    };

    const progressOkAction = () => {
      if (isDeleteSuccess) {
        updateOpenDelete(false);
        updateOpenDeleteProgress(false);
      } else {
        updateOpenDeleteProgress(false);
      }
    };
    return (
      <div>
        <div className={classes.scrollTable} id="scrollTableId">
          <Table stickyHeader>
            <GochiChildFoodListTableHead
              order={order}
              orderBy={orderBy}
              onRequestSort={handleRequestSort}
              roles={roles}
            />
            <GochiChildFoodListTableBody
              list={list}
              emptyRows={emptyRows}
              page={page}
              rowsPerPage={rowsPerPage}
              updateOpenDetailModal={updateOpenDetailModal}
              detailOpenAction={detailOpenAction}
              editOpenAction={editOpenAction}
              deleteOpenAction={deleteOpenAction}
              setTargetRowId={setTargetRowId}
              roles={roles}
              order={order}
              orderBy={orderBy}
            />
          </Table>
        </div>
        <div>
          <ExPagination
            searchResults={list}
            rowsPerPage={rowsPerPage}
            page={page}
            handleChangePage={handleChangePage}
            handleChangeRowsPerPage={handleChangeRowsPerPage}
            totalCount={totalCount}
            offset={offset}
            selectedPage={selectedPage}
          />
        </div>
        <Modal
          open={openDetailModal}
          onClose={() => {
            updateOpenDetailModal(false);
          }}
        >
          <GochiChildFoodListDetail
            updateOpenDetailModal={updateOpenDetailModal}
            updateOpenEditModal={updateOpenEdit}
            detail={detail}
          />
        </Modal>
        <Modal open={openEdit}>
          <GochiChildFoodListEdit
            name={name}
            openEditConfirm={openEditConfirm}
            updateOpenEdit={updateOpenEdit}
            updateOpenEditConfirm={updateOpenEditConfirm}
            editInput={detail}
            searchKey={searchKey}
          />
        </Modal>
        <DeleteDialog
          openDelete={openDelete}
          updateOpenDelete={updateOpenDelete}
          cancelAction={cancelAction}
          deleteAction={deleteAction}
          targetRowId={targetRowId}
          target="メニュー"
        />
        <ProgressDialog
          openProgress={openDeleteProgress}
          progressOkAction={progressOkAction}
          loading={loading}
          resultMessage={resultMessage}
        />
      </div>
    );
  }
);

export default withRouter(withStyles(styles)(Main));
